<template>
  <div class="page-wrapper">
    <div class="page-content">
      <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
        <div class="breadcrumb-title pe-3">Home Section Two</div>
        <div class="ps-3">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb mb-0 p-0">
              <li class="breadcrumb-item">
                <router-link to="/dashboard">
                  <i class="bx bx-home-alt"></i>
                </router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                Home Section Two
              </li>
            </ol>
          </nav>
        </div>
      </div>
      <form @submit.prevent="updateCms()">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">Home Section Two</h5>
            <hr />
            <div class="form-body mt-4">
              <div class="row">
                <div class="col-lg-8 mb-3">
                  <div class="border border-3 p-4 rounded">
                    <div class="row">
                      <div class="col-12 mb-3">
                        <label class="form-label">Section Title:</label>
                        <input
                          type="text"
                          v-model="cmsData.title"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label class="form-label">Section Subtitle:</label>
                        <input
                          type="text"
                          v-model="cmsData.description"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-8 mb-3">
                  <div class="border border-3 p-4 rounded">
                    <div class="row">
                      <div class="col-12 mb-3">
                        <label class="form-label">Card One Title:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardOneTitle"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label class="form-label">Card One Subtitle:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardOneSubtitle"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label class="form-label">Card One Button Text:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardOneButtonText"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label class="form-label">Card One Button Link:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardOneButtonLink"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <div class="row">
                          <div class="col-12">
                            <label for="inputProductTitle" class="form-label">
                              Card One Image:
                              <strong
                                >[Preferred Image Size: 561X599, Max Upload
                                Limit: 1MB]</strong
                              >
                            </label>
                          </div>
                          <div class="col-12">
                            <input
                              class="form-control mt-3"
                              type="file"
                              ref="cardOneImage"
                              accept="image/*"
                              @change="
                                handleUploadImage(
                                  'cardOneImage',
                                  'cardOneImagePrev',
                                  'cardOneImage',
                                  $event
                                )
                              "
                            />
                          </div>
                        </div>
                        <div class="mt-3">
                          <img
                            style="position: relative; left: 11px"
                            v-if="preview.cardOneImagePrev"
                            :src="preview.cardOneImagePrev"
                            height="100"
                          />
                          <img
                            style="position: relative; left: 11px"
                            v-else-if="cmsData.cardOneImage"
                            :src="cmsData.cardOneImage"
                            height="100"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-8 mb-3">
                  <div class="border border-3 p-4 rounded">
                    <div class="row">
                      <div class="col-12 mb-3">
                        <label class="form-label">Card Two Title:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardTwoTitle"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label class="form-label">Card Two Subtitle:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardTwoSubtitle"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label class="form-label">Card Two Button Text:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardTwoButtonText"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label class="form-label">Card Two Button Link:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardTwoButtonLink"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <div class="row">
                          <div class="col-12">
                            <label for="inputProductTitle" class="form-label">
                              Card Two Image:
                              <strong
                                >[Preferred Image Size: 561X599, Max Upload
                                Limit: 1MB]</strong
                              >
                            </label>
                          </div>
                          <div class="col-12">
                            <input
                              class="form-control mt-3"
                              type="file"
                              ref="cardTwoImage"
                              accept="image/*"
                              @change="
                                handleUploadImage(
                                  'cardTwoImage',
                                  'cardTwoImagePrev',
                                  'cardTwoImage',
                                  $event
                                )
                              "
                            />
                          </div>
                        </div>
                        <div class="mt-3">
                          <img
                            style="position: relative; left: 11px"
                            v-if="preview.cardTwoImagePrev"
                            :src="preview.cardTwoImagePrev"
                            height="100"
                          />
                          <img
                            style="position: relative; left: 11px"
                            v-else-if="cmsData.cardTwoImage"
                            :src="cmsData.cardTwoImage"
                            height="100"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-8 mb-3">
                  <div class="border border-3 p-4 rounded">
                    <div class="row">
                      <div class="col-12 mb-3">
                        <label class="form-label">Card Three Title:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardThreeTitle"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label class="form-label">Card Three Subtitle:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardThreeSubtitle"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label class="form-label">Card Three Button Text:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardThreeButtonText"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <label class="form-label">Card Three Button Link:</label>
                        <input
                          type="text"
                          v-model="cmsData.cardThreeButtonLink"
                          class="form-control"
                          id="inputPageHeaderTitle"
                          placeholder="write here.."
                        />
                      </div>
                      <div class="col-12 mb-3">
                        <div class="row">
                          <div class="col-12">
                            <label for="inputProductTitle" class="form-label">
                              Card Three Image:
                              <strong
                                >[Preferred Image Size: 561X599, Max Upload
                                Limit: 1MB]</strong
                              >
                            </label>
                          </div>
                          <div class="col-12">
                            <input
                              class="form-control mt-3"
                              type="file"
                              ref="cardThreeImage"
                              accept="image/*"
                              @change="
                                handleUploadImage(
                                  'cardThreeImage',
                                  'cardThreeImagePrev',
                                  'cardThreeImage',
                                  $event
                                )
                              "
                            />
                          </div>
                        </div>
                        <div class="mt-3">
                          <img
                            style="position: relative; left: 11px"
                            v-if="preview.cardThreeImagePrev"
                            :src="preview.cardThreeImagePrev"
                            height="100"
                          />
                          <img
                            style="position: relative; left: 11px"
                            v-else-if="cmsData.cardThreeImage"
                            :src="cmsData.cardThreeImage"
                            height="100"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="d-grid col-lg-8">
                  <button type="submit" class="btn btn-primary">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script src="../js/home-banner-slider.js"></script>
